import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import EnterpriseNavigation from '../../../../components/EnterpriseNavigation';
import EnterpriseMembersContext from 'providers/EnterpriseMembers/EnterpriseMembers.context';
import { isSingleElementArray } from 'utils';
import useCreateSelectOptions from 'hooks/useCreateSelectOptions';
import { ENTERPRISE_BUSINESS_UNIT } from '../../../../../Portfolio/components/PortfolioSellerFilters/data';
import { ENTERPRISE_MEMBER_INVITATION_STATUS } from 'models/Enterprises';
import { BROKER_STATUS, SENIORITY, BROKER_STATUS_TRANSLATION } from './data';
import { LIMIT_PARAM_KEYWORD } from 'data/global';
import { PER_PAGE } from 'components/NumberOfResultsPerPageFilter/NumberOfResultsPerPageFilter.component';
import { FilterOption } from 'models/Filters';
import { ManagePeopleActions } from '../../../../../AdminDashboard/subrouters/Enterprises/subrouters/Enterprise/pages/ManagePeople/components/ManagePeopleActions';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';
import MultiFilter from 'components/MultiFilter';

import './TeamFilters.styles.scss';
import './TeamFilters.styles.responsive.scss';

type TeamFiltersProps = {
  className?: string;
  withNavigation?: boolean;
};

const TeamFilters: React.FC<TeamFiltersProps> = (props) => {
  const { className, withNavigation = true } = props;

  const classes = classNames('team-filters', className);

  const { isOfficeManager } = useContext(CurrentUserContext);
  const { units, memberSeniorities } = useContext(EnterpriseMembersContext);

  const { t } = useTranslation();
  const createSelectOptions = useCreateSelectOptions();

  const filterOptions = useMemo(
    () =>
      [
        ...(!isSingleElementArray(units) && !isOfficeManager
          ? [
              {
                value: ENTERPRISE_BUSINESS_UNIT,
                label: t('businessUnit'),
                isMultiple: true,
                options: units,
              },
            ]
          : []),
        {
          value: BROKER_STATUS,
          label: t('status'),
          options: Object.values(ENTERPRISE_MEMBER_INVITATION_STATUS).map(
            (value) => ({
              value,
              label: t(BROKER_STATUS_TRANSLATION[value]),
            }),
          ),
        },
        ...(!isSingleElementArray(memberSeniorities)
          ? [
              {
                value: SENIORITY,
                label: t('seniority'),
                options: memberSeniorities,
              },
            ]
          : []),
        {
          value: LIMIT_PARAM_KEYWORD,
          label: t('limit'),
          shouldSortOptions: false,
          options: createSelectOptions(PER_PAGE),
        },
      ] as FilterOption[],
    [units, isOfficeManager, t, memberSeniorities, createSelectOptions],
  );

  return (
    <div className={classes}>
      {withNavigation && <EnterpriseNavigation />}

      <div className="optional-filters">
        <ManagePeopleActions />
        <MultiFilter filterOptions={filterOptions} />
      </div>
    </div>
  );
};

export default TeamFilters;
